var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 781.067,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4689.4 5350.2c-96.89 37.75-152.22 49.22-171.46 60.19-59.07 30.6-74.14 27.27-83.08 37.58-18.1 20.81-39.03 42.29-70.89 58.23-14.83 5.21-77.59 30.83-110.77 29.11-3.78-47.57 94.51-147.16 37.47-118.62-10.27 5.12-26.21 12.26-44.95 20.33l291.36-482.47 152.32 395.65",
    style: {
      fill: "#2a4ea8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4537.08 4954.55-291.36 482.47c-70.08 30.14-179.44 73.31-179.44 73.31-12.83-42.01 86.06-139.43 71.05-169.51-2.12-4.26-3.56-7.22-4.51-9.19 2.66 6.23 6.85 18.1-4.3 6.96-13.76 17.52-20.11 21.77-37.59 46.29-59.31-18.32-161.44-138.81-269.5-295.03l5.73-63.4 709.92-71.9",
    style: {
      fill: "#2f5db3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3802.52 5062.22c-6.81-10.04-13.64-20.22-20.48-30.51l45.12-5.26-24.64 35.77",
    style: {
      fill: "#5291c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5099.49 4940.38c34.44 46.71 58.11 103.84 23.92 139.93-45.26 47.85 4.72-1.03-66.23 85.9-31.18 38.28-100.91 53.24-161.48 89.57-82.9 43.13-151.28 72.99-206.3 94.42l-152.32-395.65 562.41-14.17",
    style: {
      fill: "#2958af",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3782.04 5031.71a4327.335 4327.335 0 0 1-40.41-61.95l85.53 56.69-45.12 5.26",
    style: {
      fill: "#6accc7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4545.67 4829.92c30.81-9.63 72.34-14.8 94.12 6.96 40.8 40.8 174.42 47.74 239.53 36.5 10.18-1.77 52.36-.33 70.06 5.96 2.02-12.09 64.76-20.34 82.36-8.07 18.57 12.93 45.43 38.83 67.75 69.11l-562.41 14.17 8.59-124.63",
    style: {
      fill: "#3074c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3878.07 4262.58 525.81-35.49c-8.66 61.99-10.57 172.02-1.34 381.38 1.94 44.01-4.35 153.69 35.87 193.86 18 18 55.36 33.63 73.35 42.22 6.39-4.19 18.88-9.94 33.91-14.63l-8.59 124.63-659.01-691.97",
    style: {
      fill: "#388ed4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3827.16 5026.45 50.91-763.87 659.01 691.97z",
    style: {
      fill: "#3781cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3827.16 5026.45-85.53-56.69c-131.25-204.92-257.92-438.21-315.06-583.17l451.5-124.01-50.91 763.87",
    style: {
      fill: "#3e97d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3216.05 3441.81-467.12 182.51c-305.2-80.62-487.18-169.52-602.25-250.11l131.78-273.89 937.59 341.49",
    style: {
      fill: "#cee538",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5105.96 3753.59c-21.68 4.42-37.08 7.12-37.08 7.12s-141.33-31.87-225.08-57.64l58.74-117.48 203.42 168",
    style: {
      fill: "#357fca",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3878.07 4262.58-451.5 124.01c-30.11-76.35-40.94-128.21-22.96-138.44 37.14-18.58 159.78 13.28 25.1-92.5-32.61-25.54-157.58-256.03-169.84-268.29-18.97-18.91-75.13-54.49-87.51-79.19-2.7-5.38-8.92-11.43-17.66-17.93l62.35-348.43 662.02 820.77",
    style: {
      fill: "#7ed4cf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3153.7 3790.24c-52.12-38.72-194.31-93.69-220.32-121.67-66.04-14.38-127.39-29.17-184.45-44.25l467.12-182.51-62.35 348.43",
    style: {
      fill: "#a2d959",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.14 3087.16c-4.93-1.09-9.72-2.06-14.38-2.84-73.76-12.68-239.365 41.47-381.713 42.23-152.711.78-354.934-59.9-354.934-59.9 128.825-20.45 180.864-61.69 277.032-94.55l578.705 17.39-104.71 97.67",
    style: {
      fill: "#de1e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4621.66 3771.21c-10.97 134.95-68 254.18-182.04 368.63-15.13 15.12-28.08 32.33-35.74 87.25l-525.81 35.49 743.59-491.37M4843.8 3703.07c-21.98-6.77-40.01-13.1-50.45-18.33-5.4-2.69-16.94-4.66-31.61-6.1l140.8-93.05-58.74 117.48",
    style: {
      fill: "#3a93d7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3611.46 2953.54 1106.87 541.87-.97.4 1-.39 184.18 90.17-140.8 93.05c-45.71-4.5-122.12-3.88-139.72-3.88 2.26 33.09 2.18 65.2-.36 96.45l-743.59 491.37-266.61-1309.04",
    style: {
      fill: "#45b2e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.91 3113.87c-39.92-10.28-72.03-20.57-99.77-26.71l104.71-97.67-4.94 124.38",
    style: {
      fill: "#db1e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.11 3131.07c-29.6-5.15-55.76-11.17-79.2-17.2l4.94-124.38 74.26 141.58",
    style: {
      fill: "#dc4120",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3878.07 4262.58-662.02-820.77 395.41-488.27z",
    style: {
      fill: "#73d1e7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5058.03 3572.2c33.25 10.92 76.46 4.83 122.09-10.52l388.26-33.44c-72.23 53.04-197.64 92.9-267.67 129.27-22.21 14.84-43.6 51.17-79.53 65.57-29.74 11.94-80.55 23.43-115.22 30.51l-203.42-168 155.49-13.39",
    style: {
      fill: "#3166ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2278.46 3100.32-131.78 273.89c-209.22-146.53-197.2-265.58-302.18-257.48-88.88 6.84-140.57 28.08-233.8 29.12-77.54.83-140.4-5.66-192.59-14.78l-74.26-141.58 934.61 110.83",
    style: {
      fill: "#e56b19",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2278.46 3100.32 660.21-435.35c11.03 2.77 22.23 5.31 33.57 7.64l243.81 769.2-937.59-341.49",
    style: {
      fill: "#d0e857",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4718.36 3495.42 63.17-24.33c-20.75 7.26-41.76 15.6-63.2 24.32l-1106.87-541.87 98.13-71.03c24.78 13.95 59.24 35.47 107.07 69.64 290.42 176.84 312.94 163.78 457.74 308.66 12.61 12.54 149.34-.69 235.3 2.68 55.95 2.26 229.48 7.69 340.38-.93l29.26 180.1c-20.65 5.54-41.45 11.06-62.48 17.15 17.19 8.51 42.66 20.49 70.71 33.52l14.97 92.26-184.18-90.17",
    style: {
      fill: "#4dbeef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4954.58 3524.36c38.84 17.94 74.14 34.32 91.43 42.95 3.82 1.92 7.86 3.52 12.02 4.89l-155.49 13.39 52.04-61.23M5637.15 2757.09c40.22 31.24-59.66 151.91-108.76 178.67-108.18 72.57-180.11 208.19-296.26 278.46-56.33 59.41-89.35 109.85-134.14 141.37l517.73-609.28c11.02 3.44 18.64 7.16 21.43 10.78M5443.01 3403.02c25.95-26.01 101.94-34.26 116.49-48.88 20.41-20.4 21.5-87.91 58.45-98.85 7.91-2.33 56.97-6.86 128.13 6.14 2.62.49 5.28.97 7.96 1.5l-41.36 203.13c-26.67 1.83-98.48 20.26-119.14 40.91-7.33 7.33-15.83 14.41-25.16 21.27l-388.26 33.44c106.36-35.75 225.83-121.59 262.89-158.66",
    style: {
      fill: "#305db3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4892.71 3258.04c46.31-6.65 83.44-23.13 109.69-49.34 60.75-60.8 139.24-101.06 202.4-164.28 20.35-20.34 29.33-62 49.27-81.95 23.83-23.89 97.65-59.48 112.2-81.25 25.22-37.89-5.04-110.43 35.42-133.64 55.53-25.65 166.43-16.14 214.03-1.27l-517.73 609.28c-7.52 5.29-15.37 10.07-23.73 14.25-65.83 37.46-129.67 55.3-194.92 72.82l-29.26-180.1c15.63-1.19 30-2.7 42.63-4.52M4887.57 3493.33c21.72 10.11 44.92 20.81 67.01 31.03l-52.04 61.23-14.97-92.26",
    style: {
      fill: "#3573c2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3672.78 2863.61c8.82 4.01 20.79 9.88 36.81 18.9l-98.13 71.03 61.32-89.93",
    style: {
      fill: "#92dac7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1822.18 2921.15c-.07 27.38-1.31 45.78-.26 56.22 2.94 30.17 1.55-2.01.26-56.22zm456.28 179.17-934.61-110.83 420.65-212.84c33.33 35.9 54.01 62.52 54.89 73.29.95 11.57 1.58 22.28 2.01 32.3-.71-43.13-.87-92.59.99-134.86l279.33-141.34 176.74 494.28",
    style: {
      fill: "#f17116",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3216.05 3441.81-243.81-769.2c22.31 4.57 45.08 8.29 67.8 11.09l571.42 269.84-395.41 488.27",
    style: {
      fill: "#b4e3a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1179.03 2469.96 287.3 35c2.71 1.77 5.4 3.55 8.1 5.38l-180.4 55.62c-39.48-52.58-88.47-82.55-115-96M1148.03 2610.98 465.625 2821.4C253.375 2758.06 0 2651.21 0 2651.21s529.828-44.94 784.203 39.87c34.094 11.34-99.883-93.05-178.5-272.77-2.769-6.31-5.453-12.73-8.09-19.19l312.52 38.07c77.344 64.63 159.267 125.84 237.897 173.79",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1425.73 2709-81.88 280.49-578.705-17.39c56.632-19.35 128.566-35.79 240.535-43.38-125.035-38.56-269.211-33.07-489.325-92.82a2197.816 2197.816 0 0 1-50.73-14.5l682.405-210.42c104.63 63.85 203.4 104.23 277.7 98.02M1325.9 2619c-9.22-19.82-20.13-37.4-31.87-53.04l180.4-55.62c2.58 1.75 5.15 3.55 7.72 5.38l-53.59 183.58c-30.44-7.18-77.65-26.37-102.66-80.3",
    style: {
      fill: "#ed1e24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1822.39 2747.38c1.64-37.39 4.86-69.16 10.7-85.92.4-1.18 22.36-39.41 51.38-90.22l217.25 34.8-279.33 141.34M1425.73 2709c8.42-.71 16.52-2.01 24.28-3.93 16.23-1.91 2.64-.07-21.45-5.77l53.59-183.58c12.51 8.84 24.84 18.44 36.86 28.9 95.07 82.64 188.68 170.84 245.49 232.03l-420.65 212.84 81.88-280.49",
    style: {
      fill: "#f2591a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2101.72 2606.04 766.05 37.25c22.17 8.22 46.06 15.46 70.9 21.68l-660.21 435.35-176.74-494.28",
    style: {
      fill: "#ebda1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.145 2063.26c39.925 69.8 189.136 230.32 360.988 373.93l-312.52-38.07c-72.199-178.02-92.422-412.7-48.468-335.86M1159.77 2461.19c-37.85-42.95 145.32-61.01 306.56 43.77l-287.3-35c-11.87-6.03-19.26-8.77-19.26-8.77",
    style: {
      fill: "#f0401e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3040.04 2683.7c11.45 1.4 22.9 2.58 34.26 3.48 138.82 13.95 350.83 56.41 496.79 122.39l40.37 143.97-571.42-269.84",
    style: {
      fill: "#cee86d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3571.09 2809.57c25.75 11.65 49.47 24.02 70.34 37.08 2.47 1.78 2.07 1.39 3.21 2.25-4.01-3.14-7.68-6.02 5.27 3.2 1.67 3.05 7.7 4.6 22.87 11.51l-61.32 89.93-40.37-143.97",
    style: {
      fill: "#c1e7aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2101.72 2606.04-215.68-1201.19 151.37 35.12c-14.84 71.21-24.84 136.18-32.09 173.93 23.78-45.79 56.28-104.53 84.82-161.68l198.04 45.95c-77.19 127.64-165.67 256.59-138.72 377.23 13.25 28.18 27.8 55.93 43.24 83.42 157.39 12.45 290.74 141.43 419.03 220.88 8.82 7.18 17.02 14.61 24.68 22.24l-534.69 404.1",
    style: {
      fill: "#f9cc07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2101.72 2606.04 534.69-404.1c105.06 104.45 105.61 245.9 96.64 317.4-6.26 49.87 52.19 93.4 134.72 123.95l-766.05-37.25",
    style: {
      fill: "#f0ee07",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2101.72 2606.04-217.25-34.8c57.5-100.69 142.73-250.84 143-260.21 8.75-48.51.17-85.77-19.42-115.65-.59-.7-1.19-1.6-1.8-2.68-66.77-97.07-251.39-114.91-329.19-190.93-2.48-2.4-3.77-6.43-4.13-11.66l62.31-171.13a80.94 80.94 0 0 1 2.09-3.38c39.81-59.64 95.5-200.46 119.38-330.21l29.33-80.54 215.68 1201.19",
    style: {
      fill: "#f68a11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1856.71 1485.39c4.96-26.93 8.54-53.36 10.33-78.54l19-2-29.33 80.54M1735.24 1818.98l-62.31 171.13c-2.67-38.72 46.65-144.61 62.31-171.13",
    style: {
      fill: "#f57d14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2074.14 1286.12c-3.17 12.63-5.04 25.89-6.44 30.71-11.91 40.48-21.88 82.79-30.29 123.14l-151.37-35.12 188.1-118.73M2141.9 1333.62c3.73-11.29-12.26-45.79 12.27-70.77 19.65-19.99 30.03-36.97 35.53-49.67L2429.27 1062c8.85.22 17.42.29 25.57.15 84.64-1.35-12.67 184.23-57.36 215.71-29.97 24.06-24.76 56.38-36.8 84.8-18.9 44.73-44.99 90.03-72.5 135.51l-198.04-45.95c21.19-42.43 40.19-83.94 51.76-118.6",
    style: {
      fill: "#fac907",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2195.76 1188.18c-1.82-21.73-3.66-102.29 10.78-111.96 43.95-29.4 144.73-16.22 222.73-14.22l-239.57 151.18c6.85-15.84 6.06-25 6.06-25M1971.1 1070.21c72.81-3.25 159.42 2.68 162.26 13.51 7.06 33.69-2 142.96-47.38 176.84-5.31 3.93-9.08 14.5-11.84 25.56l-188.1 118.73 85.06-334.64",
    style: {
      fill: "#f8a40d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.04 1406.85c.63-8.79 1.02-17.45 1.19-25.9l17.81 23.9-19 2",
    style: {
      fill: "#f46a17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.23 1380.95c.86-43.32-4.54-81.55-18.69-109.86-17.31-34.66-.35-18.21 16.45-68.53 10.43-31.29-28.83-75.98 8.18-113.97 10.31-10.55 50.86-16.3 96.93-18.38l-85.06 334.64-17.81-23.9",
    style: {
      fill: "#f57d14",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 738.053)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorse);
export default __webpack_public_path__ + "static/media/horse.f37461c3c3c76e31b6e57eb105a83ca5.svg";
export { ForwardRef as ReactComponent };